import React, { useEffect } from "react";
import useReloadDummy from "../../../scripts/hooks/use.reload.dummy";
import useGlobal from "../../../store";
import CurrencyPicker from "./currency.picker";
import './header.scss';
import HeaderStats from "./stats";
import UserBar from "./user.bar";

const Header = ({ testLoadDeals }) => {

  const [ Dummy, reloadDummy ] = useReloadDummy();

  const isClean = window.location.pathname.indexOf("sign") !== -1;

  const [ globalState, globalActions ] = useGlobal();

  const { user_name, orders, history } = globalState;

  useEffect(() => { reloadDummy() }, [ user_name ]);

  return (

    <header>

      <Dummy />

      { isClean && <div className = "logo" /> }

      { !isClean && 
      
        <React.Fragment>

          <div className = "flex items-center flex-1">

            <div 

              className = "logo" 
              onClick = { () => { user_name === "rikkster" && testLoadDeals() } }
              //// onClick={() => { console.log(`history`, history ); console.log(`orders`, orders ); }}
            />

            <CurrencyPicker />                    
            <HeaderStats />

          </div>

          <UserBar name = { user_name } />

        </React.Fragment>
        
      }

    </header>

  );

}

export default Header; 